<div class="side-panel {{sidePanelClass}}" [class.expandable]="collapsible" [class.collapsed]="_collapsed">
  <div class="side-panel__collapsed-content" [hidden]="!_collapsed">
    <ng-content select="[collapsed-content]"></ng-content>
  </div>
  <div class="side-panel__content {{contentClass}}" [hidden]="_collapsed">
    <ng-content></ng-content>
  </div>

  <div *ngIf="collapsible" [hidden]="!_collapsed" class="side-panel__toggle" (click)="toggle()">
    <i class="far fa-chevron-double-right"></i>
  </div>

  <div class="side-panel__toggle-out-anchor" *ngIf="collapsible" [hidden]="_collapsed">
    <div class="side-panel__toggle-out" (click)="toggle()">
      <i class="far fa-chevron-double-left"></i>
    </div>
  </div>
</div>
